import styled from 'styled-components';

import { grey5 } from 'approot/shared/styles/colours.style';
import { spacing12 } from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

export const SuggestedAnswerPreviewContainer = styled.div`
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  padding: ${rem(spacing12)};
`;
